import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SelectionType } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { TimesheetApiService } from 'src/app/core/services/api/timesheet-api.service';
import { TimesheetEntry } from 'src/app/shared/models/timesheet/timesheetEntry';
import { TimesheetEntrySearchParams } from 'src/app/shared/models/timesheet/timesheetSearchParams';

@Component({
  selector: 'app-overdue-timesheets-list',
  templateUrl: './overdue-timesheets-list.component.html',
  styleUrls: ['./overdue-timesheets-list.component.scss']
})
export class OverdueTimesheetsListComponent implements OnInit {
  SelectionType = SelectionType;
  
  @Input() items: TimesheetEntry[] = [];
  @Input() count = 0;
  @ViewChild('hearingsTable') hearingsTable: any;
  
  @Output() updatedCount = new EventEmitter<number>();
  params: TimesheetEntrySearchParams = new TimesheetEntrySearchParams();
  constructor(private spinner: NgxSpinnerService,
    private timesheetApi: TimesheetApiService,
    private router: Router) {
      if (!this.items.length) {
        this.loadItems();
      }
    }

  ngOnInit(): void {
  }


  loadItems() {
    this.spinner.show();
    this.timesheetApi.getOverdueTimesheetEntries(this.params).subscribe(
      r => {
        this.items = r.results;
        this.count = r.count;
        this.updatedCount.emit(r.count);
        this.spinner.hide();
      }
    )
  }

  onPage(page) {
    this.params.page = page.offset + 1;
    this.loadItems();
  }

  onSelectTimesheetRow({ selected }) {
    this.router.navigate(['files', selected[0].caseId, 'timesheet']);
  }

}
